import { BodyText, LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const integrationIconCss = "i1cd4srf";
const IntegrationIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(integrationIconCss, props.className)} />;
});
const integrationTitleCss = "i1506dyr";
const IntegrationTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(integrationTitleCss, props.className)} />;
});
export const Logo = ({
  icon
}) => icon ? <IntegrationIcon>
    {icon}
  </IntegrationIcon> : null;
export const Header = ({
  title,
  subtitle,
  ...props
}) => <IntegrationTitle {...props}>
    <LabelText size="large">{title}</LabelText>
    {subtitle && <BodyText color="muted" size="medium">{subtitle}</BodyText>}
  </IntegrationTitle>;

require("./header.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");